const GradeChapter = require("./GradeChapter");
const _ = require("lodash");
const moment = require("moment");

// Get default BA level from a class' displayedGrade
// Default computed from displayedGrade.
// (0,1,2,...,8) -> K maps to BA1; (1,2,...,8) -> (2,2,2,3,4,5,5,5).
const getLevelFromGrade = function(grade) {
	const minGrade = _.min(GradeChapter.getActiveGrades());
	const maxGrade = _.max(GradeChapter.getActiveGrades());
	return Math.max(minGrade, Math.min(maxGrade, grade - 1));
};

// Label for displayed grade in rostering/reports only. 0 = Kindergarten; 1–8 = Grade N.
const getDisplayedGradeLabel = function(grade) {
	if (grade === 0) return "Kindergarten";
	if (typeof grade === "number" && grade >= 1 && grade <= 8)
		return "Grade " + grade;
	return grade != null ? String(grade) : "";
};

const canRequestSeats = function(purchaseInfo) {
	const reason = reasonCannotRequestSeats(purchaseInfo);
	return !reason;
};

const reasonCannotRequestSeats = function(purchaseInfo) {
	const {isPilot, isOverdue, isBeta, expiredAt, costPerStudent} = purchaseInfo;
	if (expiredAt) {
		return "expiredAt";
	}
	if (isOverdue) {
		return "isOverdue";
	}
	if (isBeta) {
		return "isBeta";
	}
	if (isPilot) {
		return "isPilot";
	}
	if (costPerStudent <= 0) {
		return "costPerStudent";
	}
	return null;
};

// Helper for getting the purchase year from the relevant database field.
const getPurchaseYearFromClassesEndAt = function(classesEndAt) {
	if (!classesEndAt) return null;
	return moment(classesEndAt).year();
};

module.exports = {
	getLevelFromGrade,
	getDisplayedGradeLabel,
	canRequestSeats,
	reasonCannotRequestSeats,
	getPurchaseYearFromClassesEndAt,
};
